import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import _ from 'underscore';
import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';
import BaseTargetViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/baseTargets';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class DeviceViewModel extends BaseTargetViewModel {
  constructor(options = {}) {
    super(_.defaults({
      targetTypePrefix: 'DeviceType',
      targetRowKeys: targetConstants.rowKeys.Device,
      criterionType: 'Device',
      criterionTypeTarget: 'DeviceName',
      MTBidAdjustmentErrorCode: 'CampaignServiceInvalidDeviceTargetBidAdjustment',
      MTBidAdjustmentErrorNumber: '2934',
      targetPopupId: 'pop_BA_TargetingSettingsPopup_TargetTablet',
    }, {}, options));

    koSchema.properties(this);
  }

  isInRange(rowBid, targetRowKey) {
    return rowBid >= 0 &&
      (this[`${this.targetTypePrefix}${targetRowKey}Row`].selectedBidAdjustmentOption() === targetConstants.bidAdjustmentIncreaseValue ?
        rowBid <= targetConstants.maximumBid[`${this.targetTypePrefix}_${targetRowKey}`] :
        rowBid <= targetConstants.minimumBid[`${this.targetTypePrefix}_${targetRowKey}`]);
  }

  populateErrorMessageConstants(errors) {
    const mapping = {
      'DeviceTypeComputersErrorObservable': 'DeviceType_Computers',
      'DeviceTypeTabletsErrorObservable': 'DeviceType_Tablets',
      'DeviceTypeSmartphonesErrorObservable': 'DeviceType_Smartphones',
    };

    return _.map(errors, (bidError) => {
      let rawMessage = bidError.property === 'DeviceTypeComputersErrorObservable' && bidError.ErrorNumber === this.MTBidAdjustmentErrorNumber ?
        i18n.get('ErrorNumber_BidAdjustment_OutOfRange') :
        bidError.message;

      bidError.message = rawMessage
        .replace('{0}', targetConstants.minimumBid[mapping[bidError.property]])
        .replace('{1}', targetConstants.maximumBid[mapping[bidError.property]]);

      return bidError;
    });
  }

  onCampaignSettingsCheckChange(checked) {
    super.onCampaignSettingsCheckChange(checked);
    this.showAdGroupOverrideInformation(false);
  }

  setShowAdGroupOverrideInformation() {
    this.showAdGroupOverrideInformation(this.options.fromSettingsGrid);
  }
}
